var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 18,
    viewBox: "0 0 60 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2236 0.307916L19.4242 17.512H23.903L26.7028 0.307916H22.2236ZM15.6559 0.307916L11.3856 12.1408L10.8805 9.59274L10.7696 9.02248C10.2528 7.90869 9.05581 5.79181 6.79565 3.98524C6.12745 3.45125 5.45388 2.99552 4.80273 2.60625L8.68371 17.512H13.3503L20.4765 0.307916H15.6559ZM33.136 5.08412C33.136 3.13904 37.498 3.38898 39.4146 4.44515L40.0537 0.750163C40.0537 0.750163 38.0812 0 36.0252 0C33.8024 0 28.5241 0.972063 28.5241 5.6953C28.5241 10.1404 34.7192 10.1957 34.7192 12.5294C34.7192 14.8632 29.1629 14.4461 27.3292 12.974L26.6628 16.8361C26.6628 16.8361 28.6627 17.8082 31.719 17.8082C34.775 17.8082 39.3867 16.2249 39.3867 11.9183C39.3867 7.44533 33.136 7.02873 33.136 5.08412Z",
    fill: "#00D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4991 5.67496L44.2289 17.5078L39.4083 17.5078L46.5345 0.303682L51.2011 0.303682L55.4922 15.879C54.841 15.4897 54.1675 15.034 53.4993 14.5C51.2391 12.6934 49.5 10.5 49.1152 8.79325L49.0043 8.22299L48.4991 5.67496Z",
    fill: "#00D9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43944 1.9277C9.43944 1.9277 9.25404 0.375 7.27484 0.375H0.0842263L0 0.66681C0 0.66681 3.45638 1.3714 6.77235 4.01117C9.94122 6.53414 10.975 9.67915 10.975 9.67915L9.43944 1.9277Z",
    fill: "#F6AC1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5352 16.252C50.5352 16.252 50.7206 17.8047 52.6998 17.8047L59.8904 17.8047L59.9746 17.5129C59.9746 17.5129 56.5182 16.8083 53.2023 14.1685C50.0334 11.6455 48.9997 8.50054 48.9997 8.50054L50.5352 16.252Z",
    fill: "#F6AC1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/VisaIcon.ff3115177611c91c8b591391ecc5cb86.svg";
export { ForwardRef as ReactComponent };